import styled from 'styled-components'

import { Button, timingSlower } from '@syconium/little-miss-figgy'

import { fadeUpAndIn } from '../../../../../../brunswick/styles/shared'

// This wrapper exists because position:sticky + display:flex on the same element was buggy in Mobile Safari (April 2020)
export const Body = styled.div`
  bottom: 0;
  position: sticky;
  border-top: 1px solid ${o => o.theme.color.deprecated.stone};
`

// Sticky can't have overflow: hidden
export const Wrapper = styled.div`
  overflow: hidden;
`

export const Actions = styled.div`
  animation: ${fadeUpAndIn} ${timingSlower} ease 0s 1 both;
  background-color: white;
  display: flex;
  justify-content: center;
  margin: 0 -4px;
  padding: 15px 16px;
`

export const ActionButton = styled(Button)`
  flex: 1;
  margin: 0 4px;
  padding: 12px 36px;
`
